import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters.js'
import wallet from './modules/wallet.js'

// import createPersistedState from 'vuex-persistedstate';
//import * as Cookies from "js-cookie"

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    wallet,
  },
  getters,
  // plugins: [
  //   createPersistedState({
  //     // storage: window.sessionStorage,
  //     // storage: {
  //     //   getItem: (key) => Cookies.get(key),
  //     //   setItem: (key, value) =>
  //     //     Cookies.set(key, value, { expires: 3, secure: true }),
  //     //   removeItem: (key) => Cookies.remove(key)
  //     // },
  //     // paths: ['gasPrice', 'slippage', 'deadline', 'multipath', 'transactions', 'block'],
  //   }),
  // ],
});

export default store;